import React, { Dispatch, forwardRef, ForwardedRef } from 'react';
import { useMemo, useState } from 'react';
import { session } from '../../../types/types';
import DatePicker, { registerLocale } from "react-datepicker";
import es from 'date-fns/locale/es';
import "react-datepicker/dist/react-datepicker.css";
import {
    Row,
    Col,
} from 'reactstrap';

registerLocale('es', es);

interface DateSelectInputProps {
    value?: string;
    onClick?: () => void;
}

const SeleccionarSoloFechaCalendario = ({ sesiones, status, horaSeleccionada, setHoraSeleccionada }: { sesiones: session[], status: string, horaSeleccionada:string, setHoraSeleccionada:Dispatch<string>  }) => {
    const [fechaSeleccionada, setFechaSeleccionada] = useState<Date | null>(null);
    const [opcionSeleccionada, setOpcionSeleccionada] = useState('Selecciona Fecha');

    const parseSessionDate = (dateAsString: string) => {
        const [day, month, year] = dateAsString.split('-').map(Number);
        return new Date(year, month - 1, day);
    }

    const fechasDisponibles = useMemo(() => {
        return sesiones
            .filter((sesion) => sesion.hours.some((hour) => hour.status !== "0"))
            .map((sesion) => parseSessionDate(sesion.date));
    }, [sesiones]);

    const handleFecha = (date: Date | null) => {
        if (!date) {
            return;
        }

        const formattedDate = `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
        const sesion = sesiones.find((item) => item.date === formattedDate);
        if (!sesion) {
            return;
        }

        const firstAvailableHour = sesion.hours.find((hour) => hour.status !== "0");
        setFechaSeleccionada(date);
        setOpcionSeleccionada(`${sesion.title} - ${sesion.hours[0].hour}`);

        if (firstAvailableHour) {
            setHoraSeleccionada(firstAvailableHour.code);
        } else {
            setHoraSeleccionada('');
        }
    }

    const CustomDateSelect = forwardRef(({ value, onClick }: DateSelectInputProps, ref: ForwardedRef<HTMLDivElement>) => (
        <div
            ref={ref}
            className='select dropdown-toggle w-100'
            onClick={onClick}
            onKeyDown={(event) => {
                if ((event.key === 'Enter' || event.key === ' ') && onClick) {
                    onClick();
                }
            }}
            role='button'
            tabIndex={0}
            aria-haspopup='dialog'
        >
            <span>{opcionSeleccionada}</span>
        </div>
    ));

    return (
        <Row>
            <Col>
                <DatePicker
                    locale="es"
                    selected={fechaSeleccionada}
                    onChange={handleFecha}
                    includeDates={fechasDisponibles}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="Selecciona Fecha"
                    customInput={<CustomDateSelect />}
                    popperPlacement="bottom"
                    calendarClassName="select-date-calendar"
                    wrapperClassName="select-date-wrapper"
                />
            </Col>
        </Row>
    );
};
export default SeleccionarSoloFechaCalendario;